<template>
  <v-row>
    <v-col cols="12" class="mb-1 d-flex justify-end">
      <v-btn
        class="ma-2"
        color="primary"
        :to="{ name: 'system-admin-admins-add' }"
      >
        Add Admin
        <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
    </v-col>

    <v-col cols="12" class="mb-2">
      <v-text-field
        v-model="searchVal"
        label="Search"
        hide-details
        outlined
        clearable
        append-icon="mdi-magnify"
        @click:append="getAdmins()"
        @keydown="checkKeypress"
      />
    </v-col>

    <v-col cols="12" style="position: relative;">
      <v-card>
        <v-data-table
          class="elevation-1"
          :items="admins"
          :loading="loading"
          :headers="headers"
          :server-items-length="totalAdmins"
          :options.sync="options"
          :footer-props="tableFooterProps"
          @update:options="getAdmins"
        >
          <template v-slot:[`item.name`]="{ item }">
            <div class="custom-row d-flex align-center justify-between">
              <div class="py-2">{{ item.full_name }}</div>
              <v-btn
                class="edit-button ml-2"
                elevation="2"
                text
                x-small
                :to="{ path: 'admins/' + item.id }"
              >
                Edit
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <div class="py-2">{{ $moment(item.created_at).format('L') }}</div>
          </template>
          <template v-slot:[`item.is_active`]="{ item }">
            <div class="text-center">
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on"
                      :class="{ 'error--text': !item.is_active, 'primary--text': !item.status }"
                    >
                      mdi-circle
                    </v-icon>
                  </template>
                  <span>{{ item.is_active ? 'Active' : 'Inactive'}}</span>
                </v-tooltip>
              </span>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { TABLE_FOOTER_PROPS } from '@/global/consts';
import { getAdmins } from './api';

export default {
  name: 'AdminList',
  data: () => ({
    loading: true,
    searchVal: null,
    headers: [
      {
        text: 'Name',
        align: 'start',
        value: 'name',
      },
      {
        text: 'Email',
        align: 'start',
        value: 'email',
      },
      {
        text: 'Phone',
        align: 'start',
        value: 'mobile_phone',
      },
      {
        text: 'Created',
        align: 'start',
        value: 'created_at',
      },
      {
        text: 'Active',
        align: 'start',
        value: 'is_active',
      },
    ],
    admins: [],
    totalAdmins: 0,
    options: {
      sortBy: ['created_at'],
      sortDesc: [true]
    },
    tableFooterProps: { ...TABLE_FOOTER_PROPS },
  }),
  mounted() {
    this.getAdmins();
  },
  methods: {
    getAdmins() {
      this.loading = true;

      getAdmins(this.getQueryParams())
        .then(({ items, _meta }) => {
          this.admins = items;
          this.totalAdmins = _meta.totalCount;
        })
        .finally(() => this.loading = false);
    },
    getQueryParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const qParams = [];

      if (sortBy[0]) {
        qParams.push('sort=' + (sortDesc[0] ? '-' : '') + sortBy[0]);
      }
      qParams.push('per-page=' + itemsPerPage)
      qParams.push('page=' + page)
      if (this.searchVal) {
        qParams.push('s=' + encodeURIComponent(this.searchVal))
      }
      return qParams.join('&');
    },
    editAdmin(admin_id) {
      if (this.$store.getters.adminIs('systemAdmin')) {
        this.$router.push({ name: 'system-admin-admins-edit', params: { id: admin_id } })
      }
    },
    checkKeypress(e) {
      if (e.key == 'Enter') this.getAdmins()
    },
  }
}
</script>

<style lang="scss" scoped>
  .custom-row:hover .edit-button {
    visibility: visible;
  }

  .edit-button {
    visibility: hidden;
  }
</style>